import locale77304fa0 from '../../lang/de.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"de"},
  vueI18nLoader: false,
  locales: [{"code":"de","file":"de.js","name":"de","iso":"de"},{"code":"en","file":"en.js","name":"en","iso":"en"}],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/app/lang",
  rootRedirect: null,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://omara.at",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"de","file":"de.js","name":"de","iso":"de"},{"code":"en","file":"en.js","name":"en","iso":"en"}],
  localeCodes: ["de","en"],
  additionalMessages: [],
}

export const localeMessages = {
  'de.js': () => Promise.resolve(locale77304fa0),
  'en.js': () => import('../../lang/en.js' /* webpackChunkName: "lang-en.js" */),
}
